// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__67V7j","title":"styles_title__3I3hV"};